
//Valentine's Offer text direct static replacement
// (function () {
//   var OLD_TEXTS = [
//     "🥳 Onze jubileumuitverkoop is nu live! 🥳",
//     "🥳 Our Anniversary Sale Is On! 🥳"
//   ];
//  // var NEW_TEXT = "❤️ Onze valentijnsuitverkoop is nu live! ❤️";
//  // var NEW_TEXT = "Onze Sale voor Pasen is nu begonnen 🐰🐣";
//  // var NEW_TEXT = "🕵️ Onze mysterieuze meisa­le is nu live! 🕵️";
//  // var NEW_TEXT = "🤸🎈 Onze Play Days-uitverkoop is begonnen 🎈👩🏼‍🤝‍👨🏽";
//   var NEW_TEXT = "🎒✨ De Smart Start-uitverkoop is nu begonnen ✨📚";

//   function replaceText(root) {
//     var scope = root || document;

//     scope
//       .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSaleUp")
//       .forEach(function (el) {
//         if (OLD_TEXTS.includes(el.textContent.trim())) {
//           el.textContent = NEW_TEXT;
//         }
//       });
//   }

//   replaceText();

//   if (window.MutationObserver) {
//     new MutationObserver(function (mutations) {
//       mutations.forEach(function (m) {
//         if (m.type === "childList" || m.type === "characterData") {
//           replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
//         }
//       });
//     }).observe(document.body, {
//       childList: true,
//       subtree: true,
//       characterData: true
//     });
//   }
// })();

(function () {
  var currentDate = new Date();
  var year = currentDate.getFullYear();

  // Active period: October 19 to October 25 (inclusive)
  var startDate = new Date(year, 9, 19, 0, 0, 0);
  var endDate = new Date(year, 9, 26, 0, 0, 0);

  // Stop completely outside the active period
  if (currentDate < startDate || currentDate >= endDate) {
    return;
  }

  var OLD_TEXTS = [
   "🥳 Onze jubileumuitverkoop is nu live! 🥳",
    "🥳 Our Anniversary Sale Is On! 🥳"
  ];

  var NEW_TEXT =
    "🤸🎈 De Big Kiddo Sale is NU begonnen! 🎈👩🏼‍🤝‍👨🏽";

  function replaceText(root) {
    var scope = root || document;

    if (scope.nodeType === 1 &&
        scope.matches("h1,h2,h3,h4,h5,h6,#seasonalSale") &&
        OLD_TEXTS.includes(scope.textContent.trim())) {
      scope.textContent = NEW_TEXT;
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
        .forEach(function (el) {
          if (OLD_TEXTS.includes(el.textContent.trim())) {
            el.textContent = NEW_TEXT;
          }
        });
    }
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          var target =
            m.target.nodeType === 1
              ? m.target
              : m.target.parentNode;

          if (target) {
            replaceText(target);
          }
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();



// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Onze Cyber Monday Sale is Nu Live! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Onze <span class="black-friday-allproducts">Cyber Monday</span> Sale is Nu Live! 🥳';

//   var NEW_HEADING_TEXT = "🥳 Onze Jubileumuitverkoop Is Nu Live! 🥳";
// var NEW_HEADING_HTML = '🥳 Onze <span class="black-friday-allproducts">Jubileumuitverkoop</span> Is Nu Live! 🥳';


//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("jubileumuitverkoop is bezig") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("vandaag") &&
//         lower.includes("jubileum") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/vieren we ons\s+jubileum!?/i, "is onze Jubileumuitverkoop!");
//         newText = newText.replace(
//           /is onze Jubileumuitverkoop!/,
//           'is onze <span class="black-friday-allproducts">Jubileumuitverkoop!</span>'
//         );

//         newText = newText.replace(/🎉/g, "🎉").replace(/🥳/g, "🥳");
        
//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();


// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Onze Cyber Monday Sale is Nu Live! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Onze <span class="black-friday-allproducts">Cyber Monday</span> Sale is Nu Live! 🥳';

//   var NEW_HEADING_TEXT = "🎄 Onze Kerstuitverkoop Is Nu Live! 🎅";
// var NEW_HEADING_HTML = '🎄 Onze <span class="black-friday-allproducts">Kerstuitverkoop</span> Is Nu Live! 🎅';


//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("jubileumuitverkoop is bezig") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("vandaag") &&
//         lower.includes("jubileum") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/vieren we ons\s+jubileum!?/i, "vieren we onze Kerstuitverkoop!");
//         newText = newText.replace(
//           /vieren we onze Kerstuitverkoop!/,
//           'vieren we onze <span class="black-friday-allproducts">Kerstuitverkoop!</span>'
//         );

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");
        
//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();
